import { useEffect, useState } from "react";
import Tables from "../../table/Table";
import ApiService from "../../../services/apiService";
import { toast } from 'react-toastify'
import { Row, Modal, ModalBody, ModalFooter, ModalHeader, Container, Button, Card,Col } from "reactstrap";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { kmlTitle, settings } from "../../../constants";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { data, useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import routes from "../../../routers/routes";
import { format } from 'date-fns';
import { useRef } from "react";
import { string } from "yup";

const Kml = () => {

    const [kmlData, setKmlData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const navigate = useNavigate();
    const role = useAppSelector((state: any) => state.role.role)
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [checkboxValue, setCheckboxValue] = useState(false);
    const [kmlFile, setKmlFile] = useState(false)

    const handleButtonClick = () => {

        setIsDeleteModalOpen(false)
        setKmlFile(PREV => !PREV)
        setCheckboxValue(prev => !prev)

    };

    useEffect(() => {

        const fetchKml = async () => {
            try {

                const response = await ApiService.axiosApi('/kml', {
                    mehtod: 'GET'
                })
                if (response.success) {
                    
                    const updateData = response.data.data.map((item: any) => {
                        const formatDate = format(new Date(item.dateTime), 'yyyy-MM-dd HH:mm:ss');

                        return {
                            ...item,
                            dateTime: formatDate,
                        };
                    });

                    setKmlData(updateData);
                    toast.success(response.message || "Kml table")
                } else {
                    toast.error(response.message || "Uable to fect kml data")
                }
            } catch (error: any) {
                console.log(error)
            }
        }
        fetchKml();
    }, [refresh, kmlFile])

    const handleKml = async (event: any) => {
        const File = event.target.files?.[0];
        if (!File) return
        console.log(checkboxValue)
        const formData = new FormData();
        formData.append("file", File);
        formData.append("PlotOnMap", String(checkboxValue));

        console.log(formData)

        try {
            const response = await ApiService.axiosApi('/kml', {
                method: 'POST',
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            if (response.success) {
                toast.success("Kml Added Successfully")
            } else {
                toast.error("Unable To Add Kml")
            }
        } catch (error) {
            console.log(error);
            toast.error("Unable To Add Kml")
        }
    }

    const handleDelete = (id: string) => {
        setSelectedId(id);
        setIsModalOpen(true)
    }

    const handleDeleteKml = async (id: string) => {

        try {
            const response = await ApiService.axiosApi(`/kml/${id}`, {
                method: 'DELETE'
            })
            if (response.success) {
                toast.success("Kml Delted Successfully")
                setIsModalOpen(false);
                setRefresh(prev => !prev);

            } else {
                toast.error("Unable To Delete Kml")
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleUpdate = (id: string) => {

        navigate(`/update-kml/${id}`)
    }
    return (
        <>
            <Breadcrumbs mainTitle={kmlTitle} parent={settings} />

            <Card>
                <CommonCardHeader title="Kml List" headClass="pb-3" />
                {role === "Administrator" && (
                    <div className="d-flex justify-content-end">
                        <Button onClick={() => setIsDeleteModalOpen(true)} color="primary" className="mb-2 mx-2">Add Kml</Button>
                    </div>
                )}

                <Tables data={kmlData} columns={[
                    { header: "Date/Time", accessor: "dateTime" },
                    { header: "FileName", accessor: "fileName" },
                    { header: "Plot On Map", accessor: "plotOnMap" },
                    { header: "FileSize(KB)", accessor: "fileSizeInKB" }

                ]}
                    buttons={[
                        { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
                        { label: "Delete", onClick: handleDelete, color: "danger" }
                    ]}
                />

            </Card>
            <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(!isModalOpen)}>
                <ModalHeader>Delete Chack</ModalHeader>
                <ModalBody>Are you sure you want to delete this chack?</ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => handleDeleteKml(selectedId)}>Delete</Button>
                    <Button color="secondary" onClick={() => setIsModalOpen(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>


            <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>

                <ModalHeader>Upload Kml</ModalHeader>
                <ModalBody>
                <Col>
                    <Row className="align-items-center">
                        <Col xs="auto">
                            <label style={{ display: "flex", alignItems: "center", gap: "8px", margin: 0 }}>
                                <input
                                    type="checkbox"
                                    name="plotOnMap"
                                    checked={checkboxValue}
                                    onChange={(e) => setCheckboxValue(e.target.checked)}
                                />
                                Plot on Map
                            </label>
                        </Col>

                        <Col xs="auto">
                            <input
                                type="file"
                                accept=".kml"
                                id="profilePicUpload"
                                ref={fileInputRef}
                                onChange={handleKml}
                            />
                        </Col>
                    </Row>
                </Col>

                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => handleButtonClick()}>Upload</Button>
                    <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                </ModalFooter>

            </Modal>
        </>
    )
}

export default Kml;